export const QuoteModuleTranslations: Array<string> = [
    // title
    'Admin.QuoteFieldsAndAdministration',
    //Tabs
    'Admin.CartFieldAndCalculations.FieldsAndCalculationsTab',
    'Admin.CartFieldAndCalculations.DistributionCalculationTab',
    'Admin.CartFieldAndCalculations.VisibilityTab',
    'Admin.CartFieldAndCalculations.EditingTab',
    'Admin.CartFieldAndCalculations.LayoutTab',
    'Admin.CartFieldAndCalculations.DefinitionsTab',
    'Admin.CartFieldAndCalculations.CustomSectionsTab',

    // Tab Custom Sections
    'Admin.CartFieldAndCalculations.CustomSection.Name',
    'Admin.CartFieldAndCalculations.CustomSection.Tab',
    'Admin.CustomSections.SelectLanguage',
    'Admin.CustomSections.TitleTranslation',
    'Admin.CustomSections.Label',
    'Admin.CustomSections.DefaultLanguage',
    'Admin.CustomSections.SectionInfo',
    'Admin.CustomSections.Name',
    'Admin.CustomSections.Fields.Add',
    'Admin.CustomSections.Fields.CustomField',
    'Admin.CustomSections.Fields.Name',
    'Admin.CustomSections.Fields.QuickSearch',
    'xmlQuoteTable',
    'xmlQuoteTables',
    'xmlCustomFields',

  // Visibility Tab
    'Admin.QuoteFields.Visibility.ApplyFieldSelections',
    'Admin.QuoteFields.Visibility.Step1',
    'Admin.QuoteFields.Visibility.FieldsAreVisible',
    'Admin.QuoteFields.Visibility.InfoMessage',
    'Admin.QuoteFields.Visibility.ApplySelectionHeader',
    'Admin.QuoteFields.Visibility.For',
    'Admin.PermissionGroup',
    'Configurator.Items',
    'Admin.product_types_list.Title',
    'Admin.CartFieldLayout.Totals',
    'Admin.QuoteField.SelectFieldToEditCalculations',
    'Admin.QuoteField.permissions.InStatus',
    'Admin.QuoteField.permissions.editableFor',
    'Admin.QuoteField.ViewByStatus',
    'Admin.QuoteField.ViewByType',
    'Admin.QuoteFields.Visibility.DefaultSettings',
    'Admin.CartEditableFieldEdit.Default',
    'Admin.QuoteFields.Visibility.DefaultSettingsHelp',
    'Admin.QuoteFields.Visibility.In',
    'Admin.UserActionAuditTrail_QuoteStatus',
    'Admin.QuoteFields.Editing.InfoStatus',
    'Admin.QuoteFields.Editing.SelectQuoteStatus',
    'Admin.QuoteFields.SelectFields',
    'Admin.QuoteFields.Editing.SelectQuoteAreEditable',
    'Admin.QuoteFields.Editing.Step3Info',
    'Admin.UserCustomField.Type',
    'Admin.QuoteField.AddNewCalculation',
    'CartMathEdit.RowType',
    'Admin.QuoteField.AddField',
    'Admin.QuoteField.SearchFieldPlaceholder',
    'CartMathEdit.Active',
    'Admin.CartEditableFieldEdit.Calculations',
    'CartMathEdit.Name',
    'Admin.QuoteField.Permissions',
    'jsCartEditableFields.AddCalc',
    'Admin.QuoteField.VisibilityAndEditingPermissions',
    'Admin.QuoteField.New',
    'Admin.QuoteField.View',
    'Admin.QuoteField.Edit',
    'Admin.add_edit_cartItemAttributes.LabelLabel',
    'Admin.ContainerColumnAddEdit.AlwaysIncludeInKOContext',
    'CartUsage.Hide',
    'ProductAttributes.StartTyping',
    'Admin.CartEditableFieldEdit.AddUpdateCalculations',
    'Admin.CartEditableFieldEdit.QuoteItemsLinkHelp',
    'Admin.CartEditableFieldEdit.CustomTotalCalculation',
    'Admin.CartEditableFieldEdit.SectionsLinkHelp',
    'Admin.CartEditableFieldEdit.SectionsTotalScriptTootip',
    'Admin.CartEditableFieldEdit.ConsultScriptingHelp',
    'Admin.CartEditableFieldEdit.QuoteFields',
    'Admin.CartEditableFieldEdit.SectionFields',
    'Admin.QuoteField.CancelWarningTitle',
    'Admin.QuoteField.CancelWarningMsg',
    'Admin.QuoteField.IsFilterable',
    'Admin.QuoteField.AggregationType',
    'Admin.QuoteField.AggregationTypeHint',
    'Admin.QuoteField.AggregationTypeWarning',
    'Admin.QuoteField.AggregationTypeWarningTitle',
    'Admin.QuoteField.AggregationTypeChangedWarning',
    'Admin.QuoteField.TotalCalculationType',
    'Admin.QuoteField.TotalCalculationTypeHint',
    'Admin.QuoteField.CustomCalculationInfo',
    'Admin.QuoteField.TotalCalculationTypeHint',
    'Admin.QuoteField.DefaultOrder',
    'Admin.QuoteField.ResetCalculations',
    'Admin.DistributionCalculation.DeleteWarning',
    'Admin.DistributionCalculation.CancelDeleteWarning',
    'Admin.QuoteLayout.Columns',
    'Admin.QuoteLayout.Sections',
    'Admin.QuoteLayout.SelectLayoutItems',
    'Admin.QuoteLayout.AddColumns',
    'Admin.QuoteLayout.AddSections',
    'Admin.QuoteLayout.LayoutWithHeadersPerCell',
    'Admin.QuoteLayout.LayoutWithHeadersPerCellInfo',
    'Admin.QuoteLayout.SubscriptionFields',
    'Admin.QuoteLayout.ServiceContractFields',
    'Admin.QuoteLayout.QuoteCustomFields.Text',
    'Admin.QuoteCustomTabLayout.QuoteCustomFields',
    'Admin.QuoteCustomTabLayout.InfoMessage',
    'Admin.QuoteLayout.ColumnsAddedMsg',
    'Admin.QuoteLayout.SectionsAddedMsg',
    'Admin.QuoteLayout.InfoMessage',
    'Admin.QuoteLayout.AddColumnsInfoMessage',
    'Admin.QuoteFields.Visibility.ApplyLayoutItemSelections',
    'Admin.QPEdit.CharacterLimit',
    'Admin.QPEdit.CharacterLimitHint',
    'Admin.QuoteItemCustomFields.DisplaySummary',
    'Admin.QPEdit.NameErrorMessage',
    'Admin.QuoteLayout.QuoteCustomFields.LinkText',
    'Admin.QuoteField.Script',

    //Field Editability Tab
    'Admin.QuoteFields.Editing.Script',
    'Admin.QuoteFields.Editing.History',
    'Admin.QuoteFields.Editing.History.CompareError',
    'Admin.QuoteFields.Editing.QuoteItemCustomFieldsAccessPermission',
    'Versions.SelectExactlyTwoVersionToCompare',
    'Admin.AddEditScript.ScriptSyntaxNotOk',

    //Assets
    'Admin.Assets.Definition',
    'Admin.Assets.Permissions',
    'Admin.Assets.Search',
    'Admin.Assets.AddNewColumn',
    'Admin.Assets.Rank',
    'Admin.Assets.Label',
    'Admin.Assets.Type',
    'Admin.Assets.BrimPayloadProperty',
    'Admin.Assets.EditPermissions',
    'Admin.Assets.TranslationKeyLabel',
    'Admin.Assets.AddEdit',
    'xmlAssets',
    'Admin.Assets.AddAsset',
    'Admin.Assets.EditAsset',
    'xmlAssetsManagement',
    'Admin.Assets.AssetsPopupManagementTab',
    'Admin.Assets.CustomProperty',
    'Admin.Assets.Position',

    //Change Processes
    'Admin.ChangeProcesses',
    'Admin.ChangeProcess.Id',
    'Admin.ChangeProcess.AddNew',
    'Admin.ChangeProcess.FilterBy',
    'Admin.ChangeProcess.ReSync',
    'Admin.ChangeProcess.ResyncSuccess',
    'Admin.ChangeProcess.AllowConfigurationEdit',
    'Admin.ChangeProcess.EditChangeProcess',
    'Admin.ChangeProcessGroups',
    'Admin.ChangeProcessGroups.GroupName',
    'Admin.ChangeProcessGroups.ProcessIds',
    'Admin.ChangeProcessGroups.FilterBy',
    'Admin.ChangeProcessGroups.AdditionalSettings',
    'Admin.ChangeProcessGroups.AdditionalSettingsPlaceholder',
    'Admin.ChangeProcessGroups.AdditionalSettings.Title',
    'Admin.ChangeProcess.AdditionalSettingSaveSuccess',
    'Admin.ChangeProcessGroups.ChangeProcessGroupName',
    'ChangeProcess.SwapNotGroupWithOther',
    'xmlChangeProcesses',
    'Admin.CancelDeleteWarning',
    'Admin.SuccessfullyDeleted',
    'Admin.ChangeProcess.AllowCCTableEdit',
    'Admin.ChangeProcess.AllowCCTableEdit.Info',

    // bulk quote deletion
    'xmlBulkQuotesDeletion',
    'Admin.BulkQuoteDeletion.FilterByOwnerOrStatus',
    'Admin.BulkQuoteDeletion.QuoteNumber',
    'Admin.BulkQuoteDeletion.QuoteOwner',
    'Admin.BulkQuoteDeletion.QuoteStatus',
    'Admin.BulkQuoteDeletion.Delete',
    'Admin.BulkQuoteDeletion.SelectAll',
    'Admin.BulkQuoteDeletion.DateCreated',
    'Admin.BulkQuoteDeletion.DateModified',
    'Admin.BulkQuoteDeletion.Username',
    'Admin.BulkQuoteDeletion.UserType',
    'Admin.BulkQuoteDeletion.Email',
    'Admin.BulkQuoteDeletion.Blocked',
    'Admin.BulkQuoteDeletion.CannotDeleteBlocked',
    'Admin.BulkQuoteDeletion.SelectQuote',
    'Admin.BulkQuoteDeletion.DeleteMessageDialog',
    'Admin.BulkQuoteDeletion.DeleteMessageDialogNoQuotesSelected',
    'Admin.BulkQuoteDeletion.BulkQuoteHardDeletion',
    'Admin.BulkQuoteDeletion.BulkQuoteHardDeletionInfoMessage',
    'Admin.deleteAllQuotes_action.JSMSGConfirmDeletion',
    'Admin.BulkQuoteDeletion.Success',
    'Admin.BulkQuoteDeletion.BulkQuoteHardDelete',

    // quote visibility
    'xmlQuoteVisibility',
    'Admin.QuoteVisibilityDataTable.QuickSearch',
    'Admin.QuoteVisibilityDataTable.LabelQuoteVisibilityName',
    'Admin.QuoteVisibilityDataTable.LabelQuoteVisibilityDescription',
    'Admin.QuoteVisibilityDataTable.AddNewRule',
    'Admin.QuoteVisibility.SimpleCondition',
    'Admin.QuoteVisibility.IsMyCompany',
    'Admin.QuoteVisibility.IsMyUserType',
    'Admin.QuoteVisibility.IsMyTerritory',
    'Admin.QuoteVisibility.IsApprovalParent',
    'Admin.QuoteVisibility.IsManagingParent',
    'Admin.QuoteVisibility.IsOrderingParent',
    'Admin.QuoteVisibility.Query',
    'Admin.QuoteVisibility.SQLJoin',
    'Admin.QuoteVisibility.SQLWhere',
    'Admin.QuoteVisibility.QueryInfo',
    'Admin.QuoteVisibility.SimpleConditionInfo',
    'Admin.deflusersetup.PlaceholderForSelectUser',

    'Admin.QuoteVisibilityAdvancedConditionObject.Quote',
    'Admin.QuoteVisibilityAdvancedConditionObject.QuoteOwner',
    'Admin.QuoteVisibilityAdvancedConditionObject.User',
    'Admin.QuoteVisibilityAdvancedConditionObject.InvolvedParty',

    'Admin.QuoteVisibilityAdvancedConditionOperators.Equal',
    'Admin.QuoteVisibilityAdvancedConditionOperators.NotEqual',
    'Admin.QuoteVisibilityAdvancedConditionOperators.LessThan',
    'Admin.QuoteVisibilityAdvancedConditionOperators.LessThanOrEqual',
    'Admin.QuoteVisibilityAdvancedConditionOperators.GreaterThan',
    'Admin.QuoteVisibilityAdvancedConditionOperators.GreaterThanOrEqual',
    'Admin.QuoteVisibilityAdvancedConditionOperators.Like',

    'Admin.QuoteVisibilityAdvancedConditionProperties.FullName',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Username',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Email',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Brand',
    'Admin.QuoteVisibilityAdvancedConditionProperties.UserType',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Country',
    'Admin.QuoteVisibilityAdvancedConditionProperties.State',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Territory',
    'Admin.QuoteVisibilityAdvancedConditionProperties.UserId',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Company',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Address1',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Address2',
    'Admin.QuoteVisibilityAdvancedConditionProperties.ZipCode',
    'Admin.QuoteVisibilityAdvancedConditionProperties.ApproveParent',
    'Admin.QuoteVisibilityAdvancedConditionProperties.ManagingParent',
    'Admin.QuoteVisibilityAdvancedConditionProperties.OrderingParent',
    'Admin.QuoteVisibilityAdvancedConditionProperties.User.CustomField',

    'Admin.QuoteVisibilityAdvancedConditionProperties.QuoteStatus',
    'Admin.QuoteVisibilityAdvancedConditionProperties.QuoteMarket',
    'Admin.QuoteVisibilityAdvancedConditionProperties.Pricebook',
    'Admin.QuoteVisibilityAdvancedConditionProperties.QuoteCustomField',
    'Admin.QuoteVisibilityAdvancedConditionProperties.QuoteSalesOrganization',
    'Admin.QuoteVisibilityAdvancedConditionProperties.QuoteDistributionChannel',
    'Admin.QuoteVisibilityAdvancedConditionProperties.QuoteDivision',

    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyName',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyEmail',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyPrimaryIndustry',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyBusinessPartnerType',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyCountry',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyState',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyRegion',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedParty.City',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyPostalCode',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyAddress',
    'Admin.QuoteVisibilityAdvancedConditionProperties.InvolvedPartyCustomField',

    'Admin.QuoteVisibilityAdvancedConditionSelection.SingleSelect',
    'Admin.QuoteVisibilityAdvancedConditionSelection.Object',

    'Admin.QuoteVisibility.AdvancedConditions',
    'Admin.QuoteVisibility.AdvancedConditionsInfo',
    'Admin.QuoteVisibility.AddAdvancedCondition',
    'Admin.QuoteVisibility.RuleLogic',
    'Admin.QuoteVisibility.RuleLogicInfo',
    'Admin.QuoteVisibility.CustomRuleLogicValueInfo',
    'Admin.QuoteVisibility.SelectValue',
    'Admin.Msg.EditTitle',
    'Admin.QuoteVisibilityRuleLogicType.Custom',

    'Admin.QuoteVisibility.PermissionTypePriorityTitle',
    'Admin.QuoteVisibility.PermissionTypePriorityTitleInfoIcon',
    'Admin.QuoteVisibility.PermissionTypePriority.User',
    'Admin.QuoteVisibility.PermissionTypePriority.UserType',
    'Admin.QuoteVisibility.PermissionTypePriority.CustomGroup',
    'Admin.QuoteVisibility.PermissionTypePriority.Company',
    'Admin.QuoteVisibility.PermissionTypePriority.Brand',
    'Admin.QuoteVisibility.PermissionTypePriority.Market',
    'Admin.QuoteVisibility.PermissionTypePriority.SalesOrganization',

    // Document generation
    'DocumentGenerationTemplates.TemplateDefnTab',
    'DocumentGenerationTemplates.Filename',
    'DocumentGenerationTemplates.File',
    'DocumentGenerationTemplates.TemplateType',
    'DocumentGenerationTemplates.ContainedSections',
    'Admin.DocumentGeneration.MasterSection',
    'DocumentGenerationTemplates.Permissions',
    'DocumentGenerationTemplates.CreatedBy',
    'DocumentGenerationTemplates.ModifiedBy',
    'DocumentGenerationTemplates.DateModified',
    'DocumentGenerationTemplates.OutputTemplates',
    'DocumentGenerationTemplates.SectionTemplates',
    'DocumentGenerationTemplates.GeneralSettings',
    'Admin.DocumentGeneration.QuickSearch',
    'GenDoc.OldEngineType',
    'GenDoc.DefaultEngineType',
    'GenDoc.NewEngineType',
    'DocumentGenerationTemplates.EngineType',
    'Admin.DocumentGeneration.StatusInfoMessage',
    'Admin.DocumentGeneration.MasterSectionInfoMessage',
    'DocumentGenerationTemplates.DefaultOutputFormat',
    'DocumentGenerationTemplates.CustomersLanguageParam',
    'DocumentGenerationTemplates.TranslateQuoteInUsersDefaultDictionary',
    'DocumentGenerationTemplates.TranslateQuoteInUsersDefaultDictionaryHint',
    'Admin.appParams.DocumentTemplateGeneratedFilenamePrefix',
    'Admin.appParams.DocumentTemplateGeneratedFilenameSuffix',
    'Admin.appParams.GenDocImportFormatMode',
    'Admin.appParams.GenDocBreaksToBeUsed',
    'Admin.appParams.GenDoc.ShareDocumentCustomizations',
    'DocumentGenerationTemplates.UsedIn',
    'Admin.TablesOnQuotes.Language',
    'Admin.TableLanguageSelector.Hint',
    'Admin.GenDocDownloadTemplate.NoFileFound',
    'xsltCheckWhereSectionIsUsed',
    'xmlSectionName',
    'Admin.WhereInUse',
    'DocumentGeneration.WordDoc',
    'DocumentGeneration.WordDocx',
    'DocumentGeneration.Word',
    'DocumentGeneration.Pdf',
    'Admin.appParams.KeepSourceFormatting',
    'Admin.appParams.UseDestinationStyles',
    'Admin.AppParams.KeepDifferentStyles',
    'Admin.appParams.ColumnBreak',
    'Admin.appParams.LineBreak',
    'Admin.appParams.PageBreak',
    'Admin.appParams.ParagraphBreak',
    'Admin.appParams.SectionBreakContinuous',
    'Admin.appParams.SectionBreakEvenPage',
    'Admin.appParams.SectionBreakNewPage',
    'Admin.appParams.SectionBreakOddPage',
    'Admin.appParams.SectionBreakNewColumn',
    'Admin.appParams.GENDOC.USERCANSEEPREVIOUSDOCS',
    'Admin.appParams.GENDOC.USERCANDOWNLOADDOCWITHNOTEMPLATE',
    'Admin.appParams.DisableDeletionGeneratedDocumentsOnQuote',
    'Admin.appParams.GenDoc.HideItemsWithNoFiles',
    'Admin.appParams.GENDOC_RECONFIGURE_PRODUCTS',
    'Admin.appParams.GENDOC.USERCANDOWNLOADDOCSPRIORJAN2012',
    'DocumentGenerationTemplates.CustomersLanguageHint',
    'Admin.appParams.GENDOC.USERCANDOWNLOADDOCSPRIORJAN2012.HINT',
    'DocumentGenerationTemplates.DocumentsGeneratedInHint',
    'Msg.NotUsed',
    'Admin.DocumentGeneration.SectionStatusInfoMessage',
    'Admin.DocumentGeneration.OutputStatusInfoMessage',
    'xmlDocumentGenerationTemplates',
    'DocumentGenerationTemplates.afAddMoreFiles',
    'DocumentGenerationTemplates.afFilenameFormula',
    'DocumentGenerationTemplates.afDescriptionFormula',
    'DocumentGenerationTemplates.AdditionalFilesTab',
    'DocumentGenerationTemplates.afFileSelection',
    'DocumentGenerationTemplates.afAddPageBreak',
    'DocumentGenerationTemplates.ImageSettings',
    'DocumentGenerationTemplates.Image.CustomSettings',
    'DocumentGenerationTemplates.Image.DefaultSettings',
    'DocumentGenerationTemplates.afProcessForEachItem',
    'DocumentGenerationTemplates.afFileSelectionCheck',
    'DocumentGenerationTemplates.afFileSelectionRadio',
    'DocumentGenerationTemplates.Image.Jpg',
    'DocumentGenerationTemplates.Image.Png',
    'DocumentGenerationTemplates.afIncludedFileHint',
    'DocumentGenerationTemplates.afIncludedDescriptionHint',
    'DocumentGenerationTemplates.afSelectionTypeHint',
    'DocumentGenerationTemplates.ImageSettingsHelp',
    'Admin.AdditionalSettings',
    'DocumentGenerationTemplates.afHowToHintNew',
    'Admin.GenDoc.IncludeDocuments.Copied',
    'Admin.QuoteLayout.AvailableToAll',
    'DocumentGenerationTemplates.Label',
    'DocumentGenerationTemplates.Description',
    'DocumentGenerationTemplates.Name',
    'Admin.DefaultLanguage',
    'Admin.ActionTranslation.SelectLanguage',
    'Admin.Msg.ResetButton',
    'Admin.appParams.GenDoc.AllowGenerateButtonForMultiSectionTemplate',
    'Admin.appParams.LocalAdminCanShowCost',
    'Admin.appParams.DoNotPreselectTOOnSendMail',
    'quotation.appParams.HideSendMailAfterGenDoc',
    'Admin.appParams.HideEmailFormFromGenDoc',
    'Admin.appParams.EmailFromAndNameFieldsAreEditable',
    'Admin.appParams.HideSendDocumentToOpportunity',
    'Admin.appParams.UpdateOpportunityActivityAfterSendEmail',
    'Admin.appParams.AttachDocumentToCRMWhenSendingEmail',
    'Admin.EmailCustomerAppParam.EmailsSentBy',
    'Admin.EmailCustomerAppParam.PredefinedEmailClient',
    'Admin.appParams.DefaultEmailBodyType',
    'Admin.EmailCustomerAppParam.EmailSubject',
    'Admin.EmailCustomerAppParam.EmailBody',
    'Admin.EmailCustomerAppParam.UserCanAttachGenDoc',
    'Admin.EmailCustomerAppParam.PreSelected',
    'Admin.EmailCustomerAppParam.AvailableForUsers',
    'Admin.EmailCustomerAppParam.HiddenFromUsers',
    'Admin.EmailCustomerAppParam.CPQMailer',
    'Admin.EmailCustomerAppParam.UserMailClinet',
    'Admin.EmailCustomerAppParam.UserChooseClient',
    'Admin.EmailCustomerAppParam.PredefinedEmailClientHint',
    'Admin.GeneratedDocument',
    'Admin.SendEmail',
    'Admin.EmailCustomerAppParam.DefaultEmailBodyType',
    'Quotetion.SandMailNew.PlainText',
    'Quotetion.SandMailNew.Html',
    'Admin.appParams.DoNotPreselectCCBCCOnSendMail',
    'Admin.DocumentGeneration.ImageCompressionType.Auto',
    'Admin.DocumentGeneration.ImageCompressionType.Jpeg',
    'Admin.EnablePdfCompression',
    'Admin.PdfCompression',
    'Admin.DocumentGeneration.ImageCompressionType',
    'Admin.DocumentGeneration.ImageCompressionQuality',
    'Admin.DocumentGeneration.DownsampleImagesResolution',
    'Admin.DocumentGeneration.DownsampleImagesResolutionThreshold',
    'Admin.DocumentGeneration.ImageCompressionTypeHint',
    'Admin.DocumentGeneration.ImageCompressionQualityHint',
    'Admin.DocumentGeneration.DownsampleImagesResolutionHint',
    'Admin.DocumentGeneration.DownsampleImagesResolutionThresholdHint',

    /// general tab
    'DocumentGenerationTemplates.SimpleTemplate',
    'DocumentGenerationTemplates.MultiTemplate',
    'DocumentGenerationTemplates.TemplateCreationTools',
    'DocumentGenerationTemplates.RevisionNumber',
    'DocumentGenerationTemplates.Active',
    'DocumentGenerationTemplates.Preview',
    'DocumentGenerationTemplates.Replace',
    'DocumentGenerationTemplates.OverrideDocumentProcessingEngine',
    'DocumentGenerationTemplates.DocumentsTableTitle',
    'DocumentGenerationTemplates.RevisionDeleteWarning',
    'DocumentGenerationTemplates.SectionTypeDescription',
    'Msg.Draft',
    'Msg.Ready',
    'Msg.Warning',
    'DocumentGenerationTemplates.AddNewDocument',
    'DocumentGenerationTemplates.RevisionFileAlreadyExists',
    'DocumentGenerationTemplates.PreviewDocumentInfo',
    'DocumentGenerationTemplates.QuoteNumber',
    'QuoteDocument.QuoteNumberIsRequired',
    'DocumentGenerationTemplates.DocumentLanguage',
    'DocumentGenerationTemplates.PredefinedLanguageFormulaFieldDescription',

    /// section tab
    'DocumentGenerationTemplates.SectionsTab',
    'DocumentGenerationTemplates.UserCanUploadSections',
    'DocumentGenerationTemplates.UserCanSortSections',
    'DocumentGenerationTemplates.UserCanReplace',
    'Admin.DocumentGeneration.CanReplaceInfoMessage',
    'DocumentGenerationTemplates.UserCanDownload',
    'DocumentGenerationTemplates.SelectedByDefault',
    'DocumentGenerationTemplates.RequiredInDoc',
    'DocumentGenerationTemplates.InheritFromMaster',
    'DocumentGenerationTemplates.TemplateFileName',
    'DocumentGenerationTemplates.Replace',
    'DocumentGenerationTemplates.Section.RankInfo',
    'DocumentGenerationTemplates.Section.AddSections',
    'DocumentGenerationTemplates.Section.Confirmation',
    'DocumentGenerationTemplates.AddSection',
    'DocumentGenerationTemplates.EditSectionWarning',
    'DocumentGenerationTemplates.EditSectionWarningMessage',
    'DocumentGenerationTemplates.Section.TemplateNameInfo',

    // Manage content document
    'DocumentGenerationTemplates.ManageContentDocuments',
    'DocumentGenerationTemplates.DirectoryName',
    'DocumentGenerationTemplates.ManageContentDocuments.QuickSearch',
    'DocumentGenerationTemplates.AddNewFiles',
    'DocumentGenerationTemplates.FilesSuccessfullyUploaded',
    'DocumentGenerationTemplates.Failed',
    'DocumentGenerationTemplates.FileSuccessfullyReplaced',
    'DocumentGenerationTemplates.FileSuccessfullyUploaded',
    'DocumentGenerationTemplates.FilesFailedToUpload',
    'DocumentGenerationTemplates.PendingUpload',
    'DocumentGenerationTemplates.FileUploadStatus',
    'ContentFileVisibility.VisibleToLocalAdmin',
    'DocumentGenerationTemplates.ReplaceRevisionWithSameFileNameConfirmation',

    // visibility permissions tab
    'DocumentGenerationTemplates.Step2Visibility',
    'DocumentGenerationTemplates.VisibilityPermissionsTab',
    'DocumentGenerationTemplates.VisibilityPermissionsTabHint',
    'DocumentGenerationTemplates.VisibilityPermissionsTabHintSection',

    //related fields tab
    'DocumentGenerationTemplates.RelatedFieldHint',
    'DocumentGenerationTemplates.RelatedFields',
    'DocumentGenerationTemplates.AddQuoteField',
    'DocumentGenerationTemplates.RelatedFields.CustomFieldList',
    'DocumentGenerationTemplates.AddCustomField.QuickSearch',
    'DocumentGenerationTemplates.RequiredFieldsTab',

    //additional content tab
    'DocumentGenerationTemplates.AdditionalContent.ImageFormat',
    'DocumentGenerationTemplates.AdditionalContent.ImageResolution',
    'DocumentGenerationTemplates.AdditionalContent.ImageQuality',

     // format permissions tab
    'DocumentGenerationTemplates.FormatPermissionsTab',
    'DocumentGenerationTemplates.Step1Format',
    'DocumentGenerationTemplates.DefaultOutputFormatHint',
    'DocumentGenerationTemplates.Step2Format',

    // Doa tab
    'DocumentGenerationTemplates.DelegationForDocumentTemplates',
    'DocumentGenerationTemplates.SelectDoAGroupsInfo',
    'DocumentGenerationTemplates.Doa.DefineConditionInfoMsg',

    // QICF Formulas
    'Admin.QuoteField.Formulas',
    'Admin.QuoteField.OnInvolvedPartiesChanged',
    'Admin.QuoteField.AfterAddingProductsToQuoteCheckbox',
    'Admin.QuoteField.AfterCopyingProductsOnQuoteCheckbox',
    'Admin.QuoteField.AfterUpdatingProductsOnQuoteCheckbox',
    'Admin.QuoteField.AfterChangingValueOfQuoteCustomFields',
    'Admin.QuoteField.AfterChangingValueOfQuoteItemCustomFields',
    'Admin.QuoteField.TypeHereToSearch',
    'Admin.QuoteField.Formula',

    //Additional Documents tab
    'DocumentGenerationTemplates.PreattachedFilesTab',
    'DocumentGenerationTemplates.ConvertPreAttachedWordFilesToPDF',
    'DocumentGenerationTemplates.ConvertPreAttachedWordFilesToPDFHelp',
    'DocumentGenerationTemplates.ProcessPreAttachedFilesForEachItem',
    'DocumentGenerationTemplates.ProcessPreAttachedFilesForEachItemHelp',
    'DocumentGenerationTemplates.AddPreAttachedFiles',
    'DocumentGenerationTemplates.AdditionalDocumentFilenameFormulaHelp',
    'DocumentGenerationTemplates.AdditionalDocumentFilesDuplicateWarning',


    //Custom Fields
    'xmlCustomFields',
    'Admin.CustomFields.ColumnName.Name',
    'Admin.CustomFields.ColumnName.Label',
    'Admin.CustomFields.ColumnName.Type',
    'Admin.CustomFields.ColumnName.Rank',
    'Admin.CustomFields.ColumnName.ShowInTab',
    'Admin.CustomFields.ColumnName.ShowOnPlaceOrder',
    'Admin.CustomFields.ColumnName.PersonalData',
    'Msg.True',
    'Msg.False',
    'Admin.CustomFields.DeleteWarning',
    'Admin.CustomFields.DeleteMsg',
    'Admin.CustomFields.AddNewButton',
    'Admin.CustomFieldTranslation.CustomFieldInfo',
    'Admin.CustomFieldTranslation.UserTypeLabelsInfo',
    'Admin.CustomFieldTranslation.Label',
    'Actions.GenericAction.SaveSuccess',
    'Admin.CustomFieldTranslation.Column.Label',
    'Admin.CustomFieldTranslation.Column.DefaultLanguage',
    'Admin.CustomFieldTranslation.Column.SelectLanguage',
    'Admin.CustomFields.Definition',
    'Admin.CustomFields.Permissions',
    'Admin.QPEdit.OnQuoteCreatedEvent',
    'Admin.QPEdit.OnInvolvedPartiesChanged',
    'Admin.QPEdit.AfterAddingProductsToQuote',
    'Admin.QPEdit.AfterCopyingProductsInQuote',
    'Admin.QPEdit.AfterUpdatingProductsInQuote',
    'Admin.QPEdit.AfterDeletingProductsFromQuote',
    'Admin.QPEdit.OnCustomFieldChangedEvent',
    'Admin.QPEdit.CalculationEvents',
    'Admin.QPEdit.FreeFormCharacterLimitHint4000',
    'Admin.QPEdit.FreeFormCharacterLimitHint2000',
    'Admin.QPEdit.FreeFormCharacterLimit',
    'Admin.QPEdit.Formula',
    'Admin.QPEdit.FormulaValueCodeHint',
    'Admin.QPEdit.DefaultLabel',
    'Admin.DataProtection.ContainsPersonallyIdentifiableInformation',
    'Admin.DataProtection.SensitiveData',
    'Admin.QPEdit.ShowOnPlaceOrder',
    'Admin.DataProtection.InfoLabel',
    'Admin.QPEdit.Type',
    'Admin.QPEdit.Attribute',
    'Admin.QPEdit.UserGroupsByLabels',
    'Admin.CustomFields.Definition',
    'Admin.CustomFields.Permissions',
    'Admin.QPEdit.AutoCompleteAttribute',
    'Admin.QPEdit.Attribute',
    'Admin.CustomField.SelectTabs',
    'Admin.CustomFields.AddCustomField',
    'Admin.CustomField.DefaultAccessLevel',
    'Admin.CustomFields.AddCustomPermissions',
    'Admin.CustomFields.AddCustomPermissionsHint',
    'Admin.CustomFields.DeleteRow',
    'Admin.CustomFields.PermissionTypeColumn',
    'Admin.CustomFields.PermissionGroupColumn',
    'Admin.CustomFields.StatusColumn',
    'Admin.CustomFields.AccessLevelColumn',
    'Admin.CustomFields.AddRows',
    'Admin.PermissionTypePriorityTitle',
    'Admin.PermissionTypePriorityTitleInfoIcon',
    'CustomFieldsValidation.DuplicateAccessLevelDetails',
    'CustomFieldsValidation.AllFieldsRequired',
    'CustomFieldsAccessLevels.FilterBy',
    'CustomFieldsDataTable.FilterBy',
    'Admin.QPEdit.CalculationType',
    'Admin.QPEdit.TransferToItem',
    'Admin.QPEdit.SaveAutomatically',
    'CustomFieldsWarning.UsingDefaultMarket',
    'Admin.CustomFieldTable.DeleteConfirmation',

    // Quote Fields
    'xmlQuoteFields',
    'Admin.QuoteFields.QuoteStandardFields',
    'Admin.QuoteFields.QuoteCustomFields',
    'Admin.QuoteFields.QuickFilter',
    'Admin.QuoteFields.StandardFieldPermissionPriorities',
    'Admin.QuoteFields.StandardFieldPermissionPriorities.IconInfo',
    'Admin.QuoteFields.AddCustomPermissionsHint',
    'Admin.QuoteFields.Name',
    'StandardFieldsWarning.UsingDefaultMarket',


    // Quote field definition tab
    'Admin.CartFieldAndCalculations.QuickSearch',
    'Admin.CartFieldAndCalculations.SystemEvents',

    // Quote Tabs
    'Admin.QuoteTabs.Name',
    'Admin.QuoteTabs.Type',
    'Admin.QuoteTabs.Rank',
    'Admin.QuoteTabs.QuickFilter',
    'xmlCustomQuoteTabs',
    'Admin.QuoteTabs.Actions.Translate',
    'Admin.QuoteTabs.DeleteConfirmation',
    'Admin.QuoteTabTranslation.Column.DefaultLanguage',
    'Admin.QuoteTabTranslation.Column.Label',
    'Admin.QuoteTabTranslation.Column.SelectLanguage',
    'Admin.QuoteTabs.TabTypes.IFrame',
    'Admin.QuoteTabs.TabTypes.ImplementationFile',
    'AddEditQuoteTab.UrlBuilder',

    // bulk quote reassignment
    'xmlBulkQuoteReassignment',
    'Admin.BulkQuoteReassign.DefinePermissions',
    'Admin.BulkQuoteReassign.Everyone',
    'Admin.BulkQuoteReassign.DefineReassignRights',
    'Admin.BulkQuoteReassign.QuickFilter',
    'Admin.BulkQuoteReassign.From',
    'Admin.BulkQuoteReassign.To',
    'Admin.BulkQuoteReassign.Title',
    'Admin.BulkQuoteReassign.AddEditRightsDialog.From',
    'Admin.BulkQuoteReassign.AddEditRightsDialog.To',
    'Admin.BulkQuoteReassign.AddEditRightsDialog.SelectPermissionGroup.Placeholder',
    'Admin.PermissionGroup',
    'Admin.BulkQuoteReassign.QuoteStatuses',
    'Admin.BulkQuoteReassign.SelectedQuoteStatuses',
    'Admin.BulkQuoteReassign.ExcludeStatuses',
    'Admin.BulkQuoteReassign.ExcludeStatusesTT',

    // quote list settings
    'xmlQuoteListSettings',
    'Admin.QuoteListSettings.UserType',
    'Admin.QuoteListSettings.ColumnsLayout',
    'Admin.QuoteListSettings.Column.Add',
    'Admin.QuoteListSettings.Column.Configure',
    'Admin.QuoteListSettings.UserTypeSelect.Title',
    'Admin.QuoteListSettings.UserTypeSelect.Alert',
    'Admin.QuoteListSettings.UserTypeSelect.Save',
    'Admin.QuoteListSettings.UserTypeSelect.RemoveConfirnation.Title',
    'Admin.QuoteListSettings.UserTypeSelect.RemoveConfirnation.Content.Begin',
    'Admin.QuoteListSettings.UserTypeSelect.RemoveConfirnation.Content.End',
    'Admin.QuoteListSettings.UserTypeSelect.RemoveConfirnation.YesMsg',
    'Admin.QuoteListSettings.Column.Add.Dialog.Alert',
    'Admin.QuoteListSettings.Column.Add.Dialog.SelectColumn',
    'Admin.QuoteListSettings.Column.Add.Dialog.ConfigureColumn',
    'Admin.QuoteListSettings.Column.Add.Dialog.Label',
    'Admin.QuoteListSettings.Column.Confirmation',
    'Admin.QuoteListSettings.Column.Configuration',
    'Admin.QuoteListSettings.Column.RemoveConfirmation.Title',
    'Admin.QuoteListSettings.FiltersSettings',
    'Admin.QuoteListSettings.Column.RemoveConfirmation.Content',
    'Admin.QuoteListSettings.Column.RemoveConfirmation.YesMsg',
    'Admin.QuoteListSettings.Filter.Add',
    'Admin.QuoteListSettings.Filter.Reset',
    'Admin.QuoteListSettings.ColumnTranslate.Translation',
    'Admin.QuoteListSettings.Column.Edit',
    'Admin.QuoteListSettings.Filter.Add.Dialog.SelectFilter',
    'Admin.QuoteListSettings.Filter.Add.Dialog.ConfigureFilter',
    'Admin.QuoteListSettings.Filter.Add.Dialog.FilterOperator',
    'Admin.QuoteListSettings.Filter.Add.Dialog.QuickSearch',
    'Admin.QuoteListSettings.Filter.Add.Dialog.QuickSearchOperator',
    'Admin.QuoteListSettings.Filter.Add.Dialog.QuickSearch.Info',
    'Admin.QuoteListSettings.Filters.ResetConfirmation',
    'Admin.QuoteListSettings.Filters.ResetConfirmation.YesMsg',
    'Admin.QuoteListSettings.Filter.RemoveConfirmation.Content',
    'Admin.QuoteListSettings.Filter.RemoveConfirmation.YesMsg',
    'Admin.QuoteListSettings.Filter.RemoveConfirmation.Title',
    'Admin.QuoteListSettings.ColumnTranslate.Name',
    'Admin.QuoteListSettings.Filter.Add.Dialog.QuickSearch.Alert',
    'Admin.QuoteListSettings.Filter.QuickSearch',
    'Admin.QuoteListSettings.Filter.Configuration',
    'Admin.QuoteListSettings.UserTypes.Confirmation.Content',
    'Admin.QuoteListSettings.UserTypes.Confirmation.YesMsg',
    'Admin.QuoteListSettings.Column.Translation.Warning',
    'Admin.SelectLanguage',
    'Admin.QuoteListSettings.Filter.Add.Dialog.NoColumns',
    'Admin.QuoteListSettings.Column.Add.Dialog.NoColumns',

    // Quote Item Custom Fields
    'xmlQuoteItemCustomFields',
    'Admin.QuoteItemCustomFields.CalcualtionFormula',
    'Admin.QuoteItemCustomFields.Rank',
    'Admin.QuoteItemCustomFields.Name',
    'Admin.QuoteItemCustomFields.Type'
  ];
